import React from 'react';

const Pagination = ({ currentPage, totalPages, onPageChange, totalTutors }) => {
  const startTutor = (currentPage - 1) * 5 + 1;
  const endTutor = Math.min(currentPage * 5, totalTutors);

  const handlePrev = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const renderPageButtons = () => {
    const buttons = [];
    
    // First 3 pages
    for (let i = 1; i <= 3; i++) {
      buttons.push(
        <button 
          key={i}
          className={`pagination-btn ${currentPage === i ? 'active' : ''}`}
          data-page={i}
          onClick={() => onPageChange(i)}
        >
          {i}
        </button>
      );
    }

    // Ellipsis
    if (currentPage > 5) {
      buttons.push(<span key="ellipsis1" className="pagination-ellipsis">...</span>);
    }

    // Middle pages
    if (currentPage > 3 && currentPage < totalPages - 2) {
      buttons.push(
        <button 
          key={currentPage}
          className="pagination-btn active"
          data-page={currentPage}
          onClick={() => onPageChange(currentPage)}
        >
          {currentPage}
        </button>
      );
    }

    // Ellipsis before last pages
    if (currentPage < totalPages - 4) {
      buttons.push(<span key="ellipsis2" className="pagination-ellipsis">...</span>);
    }

    // Last 3 pages
    for (let i = totalPages - 2; i <= totalPages; i++) {
      buttons.push(
        <button 
          key={i}
          className={`pagination-btn ${currentPage === i ? 'active' : ''}`}
          data-page={i}
          onClick={() => onPageChange(i)}
        >
          {i}
        </button>
      );
    }

    return buttons;
  };

  return (
    <div className="pagination-container">
      <button 
        className="pagination-btn" 
        id="prevPage"
        onClick={handlePrev}
        disabled={currentPage === 1}
      >
        <i className="fas fa-chevron-left"></i>
      </button>
      {renderPageButtons()}
      <button 
        className="pagination-btn" 
        id="nextPage"
        onClick={handleNext}
        disabled={currentPage === totalPages}
      >
        <i className="fas fa-chevron-right"></i>
      </button>
      <span className="pagination-info">
        Showing {startTutor}-{endTutor} of {totalTutors} tutors
      </span>
    </div>
  );
};

export default Pagination;